// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__2Qz7R","prevNextPageBtn":"styles_prevNextPageBtn__1dITL","text":"styles_text__3rg6j","input":"styles_input__1frbp","select":"styles_select__2FnQw"};